import { Box, Button, Modal } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './DeactivateModal.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import { receiptsSelector } from '../../services/selector';
import { Spinner } from '../../../../common/Spinner/Spinner';

const style = {
  height: 150,
  p: 4,
  fontSize: '13px !important',
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: '#ECEFF1 !important',
  boxShadow: 24,
};

interface Props {
  header: string;
  receiptId?: any;
  select?: any;
  isShow: boolean;
  isDeactivated: boolean;
  closeModal: () => void;
  deactivateHandler: () => void;
  updateTable: () => void;
  resetSelected: () => void;
}

export const DeactivateModal: React.FC<Props> = ({
  isShow,
  header,
  deactivateHandler,
  updateTable,
  closeModal,
  resetSelected,
  isDeactivated,
}) => {
  const { deactivateLoading, deactivateResponse, deactivateErrorResponses } = useSelector(receiptsSelector);

  useEffect(() => {
    if (Object.keys(deactivateResponse).length > 0) {
      closeModal();

      updateTable();

      resetSelected();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deactivateResponse]);

  useEffect(() => {
    if (Object.keys(deactivateErrorResponses).length > 0) {
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deactivateErrorResponses]);

  return (
    <Modal
      open={isShow}
      onClose={() => {
        closeModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.spinnerWrapper}>{deactivateLoading && <Spinner />}</div>
        <div className={styles.headerButtonsWrapper}>
          <CloseIcon onClick={closeModal} />
        </div>

        <span className={styles.header}>{header}</span>

        <div className={styles.buttonWrapper}>
          <Button
            variant="contained"
            className={styles.btn}
            disabled={deactivateLoading || isDeactivated}
            onClick={deactivateHandler}
          >
            <span className={styles.btnText}>Деактивувати</span>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
